/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Meta_DescInputs */

const en_dr_meta_desc = /** @type {(inputs: Dr_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A structured, AI-facilitated discovery room: agree on the problem, the users and the riskiest hypothesis, brainwrite ideas behind a screen, vote, then hand off straight into a PRD with a traceable origin for every feature.`)
};

const id_dr_meta_desc = /** @type {(inputs: Dr_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang discovery terstruktur difasilitasi AI: sepakati masalah, pengguna, dan hipotesis paling berisiko, tulis ide di belakang layar (brainwriting), vote, lalu langsung jadi PRD dengan asal-usul yang bisa ditelusuri untuk tiap fitur.`)
};

/**
* | output |
* | --- |
* | "A structured, AI-facilitated discovery room: agree on the problem, the users and the riskiest hypothesis, brainwrite ideas behind a screen, vote, then hand o..." |
*
* @param {Dr_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_meta_desc = /** @type {((inputs?: Dr_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_meta_desc(inputs)
	return en_dr_meta_desc(inputs)
});